export default __webpack_public_path__ + "static/media/icon-contacted.448cf7f4.svg";